/* eslint-disable max-len */
import axios from 'axios';
import { errorInteractions } from '../../analytics';

// eslint-disable-next-line consistent-return
export const getMediaAssets = async (host, folder, omsId) => {
  const errorMsg = 'Get Media Assets Failed';
  try {
    if (folder && omsId) {
      const response = await axios.post(
      `${host}/api/mediagallery`,
      { folder, omsId }
      );
      return response?.data;
    }
  } catch (err) {
    const errorObject = {
      type: 'catastrophic',
      displayType: 'inline',
      pageSection: 'Get Media',
      message: errorMsg
    };
    const trackErrorInteractions = { errorObject, primaryCategory: 'error', eventName: 'post page error' };
    errorInteractions(trackErrorInteractions);
    return null;
  }
};
